import React from 'react'
import Select from 'lib/components/select'
import ChartMap from './chart-map'
import ChartSwitch from '../../chart-switch'
import withSend from 'microcosm/addons/with-send'
import RA from 'ra-config'

const {
  horizontalOptionList,
  verticalOptionList
} = RA.app.factors.chartConfig.scatterPlot

class FactorsXYScatterPlot extends React.PureComponent {
  setXFilter = event => {
    this.props.send('patchQuery', {
      xAxis: event.target.value
    })
  }

  setYFilter = event => {
    this.props.send('patchQuery', {
      yAxis: event.target.value
    })
  }

  getYAxisOptions() {
    return verticalOptionList.map(function({ text, prefix, suffix }) {
      return { text, value: prefix + suffix }
    })
  }

  getDefaultOptions() {
    const x = horizontalOptionList.find(o => o.default)
    const yOption = verticalOptionList.find(o => o.default)
    const yAxis = yOption.prefix + yOption.suffix

    return {
      xAxis: x.value,
      yAxis: yAxis
    }
  }

  getOptions() {
    return Object.assign({}, this.getDefaultOptions(), this.props.query)
  }

  render() {
    const { data, title } = this.props

    const options = this.getOptions()

    return (
      <div className="chart-container">
        <form className="chart-container__menu -wide -scatterplot split-nav">
          <div className="split-nav__main">
            <div className="chart-selector">
              <Select
                label="Vertical"
                labelFor="scatter-y-category"
                onChange={this.setYFilter}
                options={this.getYAxisOptions()}
                renderOption={this.renderYAxisOption}
                selected={options.yAxis}
              />
            </div>

            <div className="chart-selector">
              <Select
                label="Horizontal"
                labelFor="scatter-x-category"
                onChange={this.setXFilter}
                options={horizontalOptionList}
                selected={options.xAxis}
              />
            </div>
          </div>
        </form>

        <div className="chart-container__chart">
          <ChartSwitch
            title={title}
            chartMap={ChartMap}
            chart={{ text: 'Factors' }}
            aggregate={data}
            query={options}
            focus={options.selected}
          />
        </div>
      </div>
    )
  }
}

export default withSend(FactorsXYScatterPlot)



// WEBPACK FOOTER //
// ./src/components/factors/charts/x-y-scatterplot.js